export enum BasketSizeEnum {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export type IBasketRecommendation = Record<BasketSizeEnum, number>;
